module.exports = __webpack_public_path__ + "img/item_CommIllustration_03d.fad3f818.jpeg";